module.exports = __webpack_public_path__ + "static/media/cone-cream-dessert-svgrepo-com.5b0fc40d.svg";